// routes/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { is_influencer, isAuthenticated, isUser } from "../utility/auth";
const InfluencerRoutes = ({ element: Element }) => {
  console.log("is_influencer :", is_influencer());
  console.log(" isUser():", isUser());
  console.log("  isAuthenticated():", isAuthenticated());
  return is_influencer() && isUser() && isAuthenticated() ? (
    <Element />
  ) : (
    <Navigate to="/" replace />
  );
};

export default InfluencerRoutes;
